import styled from "styled-components"

export const CardContainerSkeleton = styled.div`
  width: 12.5rem;
  display: flex;
  flex-direction: column;
  text-decoration: none;
`

export const ImageSkeleton = styled.div`
  width: 12.5rem;
  height: 12.5rem;
`

export const DescriptionContainerSkeleton = styled.div`
  display: flex;
  flex-direction: column;
`

export const IdSkeleton = styled.p`
  margin: 0.3125rem 0;
  width: 1.875rem;
  height: 0.9375rem;
`

export const TitleSkeleton = styled.p`
  width: 5.625rem;
  height: 1.7rem;
`

export const TypesContainerSkeleton = styled.div`
  width: 6.8rem;
  display: flex;
  gap: 0.3125rem;
  justify-content: flex-start;
  align-self: flex-start;
`

export const TypeSpanCardSkeleton = styled.span`
  width: 6.875rem;
  height: 0.9375rem;
`
